import { Route } from 'react-router-dom'
import { lazyWithRetry as lazy } from '../lib/lazyWithRetry'

// AI Virtual Experts — Expert Console (cabinet portal). Autonomous per-persona
// experts that read the tenant's REAL posture, propose a strategy, generate an
// ordered plan and execute it under an autonomy envelope.
const ExpertConsolePage = lazy(() =>
  import('../pages/ai-experts/ExpertConsolePage').then((m) => ({ default: m.ExpertConsolePage })),
)

/**
 * Route elements for the AI Experts console. Spread into the app-wide <Routes>
 * (inside the MainLayout group, BEFORE the catch-all) in App.tsx — mirrors the
 * array-of-<Route> spread pattern already used there (cabinet settings sections).
 */
export const aiExpertsRoutes = [
  <Route key="ai-experts" path="/ai-experts" element={<ExpertConsolePage />} />,
  <Route key="ai-experts-detail" path="/ai-experts/:expert" element={<ExpertConsolePage />} />,
]
